// @flow

import { connect } from 'react-redux';
import Rum from '@ta/platform.rum';

/**
 * @ta/platform.rum is needed by both lithium and non-lithium pages but our routing setups are different for the two frameworks.
 * This is a wrapper for non-lithium pages to pass the page and uid in from redux.
 */
export default connect<{| page: ?string, puid: ?string |}, {||}, _, _, _, _>(state => ({
  page: state.route.page,
  puid: state.tracking.uid,
}))(Rum);
